import React from 'react';
import PropTypes from 'prop-types';
import { NumberInput } from '@src/components/ui/react-hook-form/number-input/number-input';
import { useFormContext, useWatch } from 'react-hook-form';

export const QuantityField = ({ price, priceUnit }) => {
    const { control } = useFormContext();
    const quantity = useWatch({ control, name: 'quantity' }) || 1;

    return (
        <>
            <span className='tw-font-medium'>Quantity</span>
            <div className='tw-flex tw-justify-between tw-gap-2'>
                <div className='tw-flex tw-gap-[8px] tw-items-end'>
                    <NumberInput
                        name='quantity'
                        variant='outlined'
                        className=''
                        placeholder='[hours]'
                        InputProps={{
                            className: 'tw-text-[16px] tw-bg-white '
                        }}
                        withStepper
                        min={1}
                        max={99}
                    />{' '}
                    / {priceUnit}
                </div>

                <div className='tw-flex tw-justify-end tw-items-center tw-flex-[1_0_0]'>
                    <span className='tw-text-[16px] tw-font-medium'>
                        [{quantity}] x ${parseFloat(price).toFixed(2)}
                    </span>
                </div>
            </div>
        </>
    );
};

QuantityField.propTypes = {
    price: PropTypes.number,
    priceUnit: PropTypes.string
};
